import { render, staticRenderFns } from "./footer_page_eng.vue?vue&type=template&id=43d02062&scoped=true"
import script from "./footer_page_eng.vue?vue&type=script&lang=js"
export * from "./footer_page_eng.vue?vue&type=script&lang=js"
import style0 from "./footer_page_eng.vue?vue&type=style&index=0&id=43d02062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d02062",
  null
  
)

export default component.exports